import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl, KTSVG, useDebounce} from '../../../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {
  GetBouncedData,
  GetReportId,
  GetSingleMessageData,
  exportAllBouncedMessageData,
  getAllBouncedMessageData,
} from '../reportSlices/reportAnalytics'
import ReactApexChart from 'react-apexcharts'
import moment from 'moment-timezone'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../../Components/NodataYet'
import {startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {Spinner} from 'react-bootstrap'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useFetchReportPaginateListGroupQuery} from '../../../../../services/cellcast.v3'

const BouncedTab = () => {
  const dispatch = useDispatch()
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const ReportId = useSelector(GetReportId)
  const messageData = useSelector(GetSingleMessageData)
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const bouncedMessage = useSelector(GetBouncedData)
  let deliveredData =
    messageData?.deliveredMessage > messageData?.recipients
      ? messageData?.recipients
      : messageData?.deliveredMessage

  const [search, setSearch] = useState({
    searchValue: '',
    page: 1,
  })

  const [exportLoading, setExportLoading] = useState(false)

  const {data: messageListRegion} =
    useFetchReportPaginateListGroupQuery(
      {
        page: search.page,
        limit: 10,
        scope: 'failed',
        messageType: 'sms',
        type: 'message',
        group: 'user_id',
        bulkId: ReportId?.id,
      },
      {
        skip: isDefaultRegion,
      }
    )

  const debouncedSearchTerm = useDebounce(search.searchValue, 300)
  useEffect(() => {
    dispatch(startLoadding())
    dispatch(
      getAllBouncedMessageData({
        id: ReportId?.id,
        params: {camp_type: ReportId?.camp_type, ...search},
      })
    )
  }, [debouncedSearchTerm, search])

  const bouncedPer = messageData?.recipients
    ? (messageData?.bouncedMessage * 100) / messageData?.recipients
    : 0

  const bouncedPerRegion = ReportId?.data?.total_recipient
    ? (ReportId?.data?.fail_message_count * 100) / ReportId?.data?.total_recipient
    : 0
  const bouncedData: any = {
    series: [bouncedPer, 100 - bouncedPer],

    options: {
      chart: {
        type: 'donut',
      },
      labels: [
        `Total Failed ${+bouncedPer?.toFixed(2)}% (${messageData?.bouncedMessage})`,
        `Messages Sent ${+(100 - bouncedPer)?.toFixed(2)}% (${deliveredData})`,
      ],

      colors: ['rgb(238, 76, 76)', 'rgb(76, 238, 189)'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }

  console.log(ReportId?.data?.fail_message_count)

  const bouncedDataRegion: any = {
    series: [bouncedPerRegion, 100 - bouncedPerRegion],

    options: {
      chart: {
        type: 'donut',
      },
      labels: [
        `Total Failed ${+bouncedPerRegion?.toFixed(2)}% (${ReportId?.data?.fail_message_count})`,
        `Messages Sent ${+(100 - bouncedPerRegion)?.toFixed(2)}% (${
          ReportId?.data?.delivered_message_count
        })`,
      ],

      colors: ['rgb(238, 76, 76)', 'rgb(76, 238, 189)'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }
  const bouncedText: any = {
    '1': 'once',
    '2': '2 times',
    '3': '3 times',
  }

  const bouncedTimeDataSeries =
    bouncedMessage?.GatewayMessageBouncedData?.map((key: any) => key?.count) || []
  const bouncedTimeDataLabel =
    bouncedMessage?.GatewayMessageBouncedData?.map(
      (key: any) =>
        `Bounced ${
          bouncedText?.[`${key?.bounced}`] ?? `${key?.bounced} times`
        } ----------------- ${+key?.count}`
    ) || []

  const bouncedTimeData: any = {
    series: [...bouncedTimeDataSeries],

    options: {
      chart: {
        type: 'donut',
      },
      labels: [...bouncedTimeDataLabel],

      colors: ['rgb(238, 76, 76)', 'rgb(76, 238, 189)'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }

  const renderDefaultRegion = () => {
    return (
      <>
        <div className='row'>
          <div className='col-md-6 px-4'>
            <div className='card p-8 py-5 h-100'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Messages Sent</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>All sent message</span>
                </h3>
              </div>
              <div className='card-body px-0 pt-5'>
                <div className='optout_summary_chart'>
                  {messageData?.bouncedMessage > 0 || true ? (
                    <div className='chart_body'>
                      {/* <img src={toAbsoluteUrl('/media/misc/bounced_message_chart.png')} alt='Image' /> */}
                      <ReactApexChart
                        options={bouncedData.options}
                        series={bouncedData.series}
                        type='donut'
                      />
                      {/* TODO: commented this out need to change to other message */}
                      {/* <div className='optout_unsubscribed'>
                    <p>Recipients who responded negativelly will also be unsubscribed.</p>
                  </div> */}
                    </div>
                  ) : (
                    <NodataYet message={'No bounces detected'} />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 px-4'>
            <div className='card p-8 py-5 h-100'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>
                    {messageData?.bouncedMessage}
                  </span>
                  <span className='text-muted mt-1 fw-bold fs-7'>Bounced</span>
                </h3>
              </div>
              <div className='card-body px-0 pt-5'>
                <div className='optout_summary_chart'>
                  {bouncedMessage?.GatewayMessageBouncedData?.length > 0 ? (
                    <div className='chart_body'>
                      {/* <img src={toAbsoluteUrl('/media/misc/bounced_message_chart.png')} alt='Image' /> */}
                      <ReactApexChart
                        options={bouncedTimeData.options}
                        series={bouncedTimeData.series}
                        type='donut'
                      />
                      {/* TODO: commented this out need to change to other message */}
                      {/* <div className='optout_unsubscribed'>
                    <p>Recipients who responded negativelly will also be unsubscribed.</p>
                  </div> */}
                    </div>
                  ) : (
                    <NodataYet message={'No bounces detected'} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-8'>
          <div className='col-12'>
            <div className='card mb-0 pt-7'>
              <div className='card-header align-items-center border-bottom-0 w-100'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Failed</span>
                </h3>
                {/* <input
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid w-250px ps-14'
                  placeholder='Search user'
                /> */}
                <button
                  onClick={() => {
                    setExportLoading(true)
                    dispatch(
                      exportAllBouncedMessageData({
                        id: ReportId?.id,
                        params: {camp_type: ReportId?.camp_type, export: true, ...search},
                      })
                    )
                      .unwrap()
                      .then((res: any) => {
                        if (res?.data?.downloadurl) {
                          let basePath = API_DOMAIN || ''
                          if (!basePath.endsWith('/')) {
                            basePath += '/'
                          }
                          window.open(`${basePath}${res?.data?.downloadurl}`, '_self')
                        }
                      })
                      .finally(() => {
                        setExportLoading(false)
                      })
                  }}
                  type='button'
                  className='btn btn-light-primary'
                >
                  {exportLoading ? (
                    <Spinner size='sm' />
                  ) : (
                    <>
                      {' '}
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              </div>
              {bouncedMessage?.items?.length > 0 ? (
                <div className='card-body pt-2'>
                  <div className='tab-content'>
                    <div className='table-responsive'>
                      <table className='table align-middle gs-0 gy-5'>
                        <thead>
                          <tr className='fw-bold text-muted text-uppercase'>
                            <th>Mobile</th>
                            <th>First Name</th>
                            <th>Full Name</th>
                            <th>Date</th>
                            <th>BOUNCES</th>
                            <th style={{width: '120px'}}>Status</th>
                          </tr>
                        </thead>
                        <tbody className='text-gray-600'>
                          {bouncedMessage?.items?.map((key: any, i: number) => {
                            return (
                              <tr key={i} className='border-dashed border-1 border-bottom'>
                                <td>{key?.mobile}</td>
                                <td>
                                  {key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                                  )
                                    ? key?.fields?.find(
                                        (key: any) =>
                                          key?.name?.toLowerCase()?.replace(/ +/g, '') ===
                                          'firstname'
                                      )?.value
                                    : '-'}
                                </td>
                                <td>
                                  {key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                                  )
                                    ? key?.fields?.find(
                                        (key: any) =>
                                          key?.name?.toLowerCase()?.replace(/ +/g, '') ===
                                          'fullname'
                                      )?.value
                                    : '-'}
                                </td>
                                <td>{moment(key?.contact?.[0]?.bouncedAt).format('l')}</td>
                                <td>{key?.contact?.[0]?.bounced}</td>
                                <td>
                                  <a
                                    className={`badge badge-light-${
                                      key?.isBlocked || key?.isBlockedByUser ? 'danger' : 'success'
                                    } fw-bold`}
                                  >
                                    {key?.isBlocked || key?.isBlockedByUser
                                      ? 'UnSubscribed'
                                      : 'Subscribed'}
                                  </a>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className='abcd '>
                      <span>Total: {bouncedMessage?.total}</span>
                      <ReactPaginate
                        previousLabel='<'
                        nextLabel='>'
                        pageCount={bouncedMessage?.totalPages}
                        onPageChange={(e: any) => setSearch({...search, page: e.selected + 1})}
                        containerClassName={'pagiantion'}
                        previousLinkClassName={'pagination__link'}
                        nextLinkClassName={'pagination__link'}
                        disabledClassName={'pagination__link--disabled'}
                        activeClassName={'pagination__link--active'}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <NodataYet message={'No bounces detected'} />
              )}
            </div>
          </div>
        </div>
      </>
    )
  }

  const renderRegionData = () => {
    const messageData = ReportId?.data

    return (
      <>
        <div className='row'>
          <div className='col-md-6 px-4'>
            <div className='card p-8 py-5 h-100'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Messages Sent</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>All sent message</span>
                </h3>
              </div>
              <div className='card-body px-0 pt-5'>
                <div className='optout_summary_chart'>
                  {messageData?.fail_message_count > 0 || true ? (
                    <div className='chart_body'>
                      {/* <img src={toAbsoluteUrl('/media/misc/bounced_message_chart.png')} alt='Image' /> */}
                      <ReactApexChart
                        options={bouncedDataRegion.options}
                        series={bouncedDataRegion.series}
                        type='donut'
                      />
                      {/* TODO: commented this out need to change to other message */}
                      {/* <div className='optout_unsubscribed'>
                    <p>Recipients who responded negativelly will also be unsubscribed.</p>
                  </div> */}
                    </div>
                  ) : (
                    <NodataYet message={'No bounces detected'} />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 px-4'>
            <div className='card p-8 py-5 h-100'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>
                    {messageData?.bouncedMessage}
                  </span>
                  <span className='text-muted mt-1 fw-bold fs-7'>Bounced</span>
                </h3>
              </div>
              <div className='card-body px-0 pt-5'>
                <div className='optout_summary_chart'>
                  {bouncedMessage?.GatewayMessageBouncedData?.length > 0 ? (
                    <div className='chart_body'>
                      {/* <img src={toAbsoluteUrl('/media/misc/bounced_message_chart.png')} alt='Image' /> */}
                      <ReactApexChart
                        options={bouncedTimeData.options}
                        series={bouncedTimeData.series}
                        type='donut'
                      />
                      {/* TODO: commented this out need to change to other message */}
                      {/* <div className='optout_unsubscribed'>
                    <p>Recipients who responded negativelly will also be unsubscribed.</p>
                  </div> */}
                    </div>
                  ) : (
                    <NodataYet message={'No bounces detected'} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-8'>
          <div className='col-12'>
            <div className='card mb-0 pt-7'>
              <div className='card-header align-items-center border-bottom-0 w-100'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Failed</span>
                </h3>
              </div>
              {messageListRegion?.items?.length > 0 ? (
                <div className='card-body pt-2'>
                  <div className='tab-content'>
                    <div className='table-responsive'>
                      <table className='table align-middle gs-0 gy-5'>
                        <thead>
                          <tr className='fw-bold text-muted text-uppercase'>
                            <th>Mobile</th>
                            <th>First Name</th>
                            <th>Full Name</th>
                            <th>Date</th>
                            <th>BOUNCES</th>
                            <th style={{width: '120px'}}>Status</th>
                          </tr>
                        </thead>
                        <tbody className='text-gray-600'>
                          {messageListRegion?.items?.map((key: any, i: number) => {
                            return (
                              <tr key={i} className='border-dashed border-1 border-bottom'>
                                <td>{key?.metadata?.receiver}</td>
                                <td>{key?.metadata?.receiverName ?? '-'}</td>
                                <td>{key?.metadata?.receiverName ?? '-'}</td>
                                <td>{moment(key?.contact?.[0]?.bouncedAt).format('l')}</td>
                                <td>{key?.contact?.[0]?.bounced}</td>
                                <td>
                                  <a
                                    className={`badge badge-light-${
                                      key?.isBlocked || key?.isBlockedByUser ? 'danger' : 'success'
                                    } fw-bold`}
                                  >
                                    {key?.isBlocked || key?.isBlockedByUser
                                      ? 'UnSubscribed'
                                      : 'Subscribed'}
                                  </a>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className='abcd '>
                      <span>Total: {messageListRegion?.total}</span>
                      <ReactPaginate
                        previousLabel='<'
                        nextLabel='>'
                        pageCount={messageListRegion?.totalPages}
                        onPageChange={(e: any) => setSearch({...search, page: e.selected + 1})}
                        containerClassName={'pagiantion'}
                        previousLinkClassName={'pagination__link'}
                        nextLinkClassName={'pagination__link'}
                        disabledClassName={'pagination__link--disabled'}
                        activeClassName={'pagination__link--active'}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <NodataYet message={'No bounces detected'} />
              )}
            </div>
          </div>
        </div>
      </>
    )
  }

  return <>{isDefaultRegion ? renderDefaultRegion() : renderRegionData()}</>
}

export default BouncedTab
